/**
 * Nutrition Stripe Animation Module
 * Handles the animation of nutrition values when they come into view
 * Uses IntersectionObserver for performance and only animates once
 */

class NutritionCounter {
  constructor(element) {
    this.element = element;
    this.overlay = element.closest('.nutrition-overlay');
    
    // Only initialize if animation is enabled
    if (!this.overlay || !this.overlay.classList.contains('animate-numbers')) {
      return;
    }
    
   // console.log('Raw value:', element.dataset.value);
    this.value = parseFloat(element.dataset.value) || 0;
   // console.log('Parsed value:', this.value);
    this.current = 0;
    this.duration = parseInt(this.overlay.dataset.animationSpeed) || 1500;
    this.startTime = null;
    this.decimals = this.value === 0 ? 0 : (this.value.toString().split('.')[1] || '').length;
    //console.log('Decimals:', this.decimals);
    
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !this.element.dataset.counted) {
       // //console.log('Starting animation for value:', this.value);
          requestAnimationFrame((timestamp) => this.animate(timestamp));
          this.element.dataset.counted = 'true';
        }
      },
      { threshold: 0.1 }
    );
    
    this.observer.observe(this.element);
  }

  animate(timestamp) {
    if (!this.startTime) {
      this.startTime = timestamp;
    }
    const progress = Math.min((timestamp - this.startTime) / this.duration, 1);
   // console.log('Progress:', progress);
    
    this.current = progress * this.value;
    const formatted = this.current.toFixed(this.decimals);
   // console.log('Current:', this.current, 'Formatted:', formatted);
    this.element.textContent = formatted;
    
    if (progress < 1) {
      requestAnimationFrame((timestamp) => this.animate(timestamp));
    }
  }
}

// Initialize counters
document.addEventListener('DOMContentLoaded', () => {
  const counters = document.querySelectorAll('[data-nutrition-counter] .nutrition-value');
//console.log('Found counters:', counters.length);
  counters.forEach(counter => new NutritionCounter(counter));
});

// For infinite scroll or dynamic content loading
document.addEventListener('shopify:section:load', () => {
  const counters = document.querySelectorAll('[data-nutrition-counter] .nutrition-value:not([data-counted])');
//console.log('Found new counters:', counters.length);
  counters.forEach(counter => new NutritionCounter(counter));
});

